export const getEnvironment = host => {
  if (host.startsWith("localhost")) return "stg";
  return host.split("-")[0];
};

export const getAppData = env => {
  const domain = env === "prod" ? "pes-prod.nike.com" : "parc-test.nikecloud.com";

  const appData = {
    Applications: [
      // {
      //   key: 1,
      //   name: 'View CBD',
      //   img: 'cbd',
      //   link: `https://${env}-parc-cbd-ui/${domain}/cbd`,
      //   type: 'Costing',
      // },
      {
        key: 1,
        name: "Mass CBD Export ",
        img: "calculator",
        link: `https://${env}-amplify-mass-cbd-export-ui.${domain}`,
        type: "Costing"
      },

      {
        key: 2,
        name: "Material Lab Test Form",
        img: "laboratory",
        link: `https://${env}-parc-material-lab-form-ui.${domain}`,
        type: "Material"
      },
      {
        key: 3,
        name: "PCX FW Library Sharing",
        img: "study",
        link: `https://${env}-parc-library-sharing-ui.${domain}`,
        type: "Material"
      },
      {
        key: 4,
        name: "Raw Material Data Sheet",
        img: "marketing",
        link: `https://${env}-parc-rmds-ui.${domain}`,
        type: "Material"
      },
      {
        key: 5,
        name: "Care and Content",
        img: "tag",
        link: `https://${env}-amplify-careandcontent-ui.${domain}`,
        type: "Material"
      }
    ]
  };

  return appData;
};
